import { render, staticRenderFns } from "./BasicInfoDetail.vue?vue&type=template&id=626ebc05&scoped=true&"
import script from "./BasicInfoDetail.vue?vue&type=script&lang=js&"
export * from "./BasicInfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfoDetail.vue?vue&type=style&index=0&id=626ebc05&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626ebc05",
  null
  
)

export default component.exports